import React, { Fragment } from 'react';
import _ from 'lodash';
import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';


class TreatmentFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            filters: {},
            activeCount: 0
        };

        this.toggleCheckbox =
            this.toggleCheckbox.bind(this);

        this.toggleCollapse =
            this.toggleCollapse.bind(this);

        this.processResponse =
            this.processResponse.bind(this);

        this.updateAPIURL =
            this.updateAPIURL.bind(this);

        this.aggregates = {
            'sample.prior_treatment': 'count'
        };
    }


    /*
     * ============================================================
     * URL HELPERS
     * ============================================================
     */

    static getTreatmentsFromQS(query) {

        if (!query || !query.treatment) {
            return [];
        }

        return _.split(
            query.treatment,
            '_'
        ).filter(Boolean);
    }


    static getFiltersFromQS(
        query,
        oldfilters
    ) {

        const selected =
            TreatmentFilter.getTreatmentsFromQS(
                query
            );

        return _.reduce(
            oldfilters,
            (result, filterProps, treatment) => {

                result[treatment] = {
                    ...filterProps,
                    active:
                        selected.indexOf(treatment) !== -1
                };

                return result;
            },
            {}
        );
    }


    static getDerivedStateFromProps(
        newprops,
        oldstate
    ) {

        const current_qs =
            qs.parse(
                newprops.location.search,
                {
                    ignoreQueryPrefix: true
                }
            );

        const newfilters =
            TreatmentFilter.getFiltersFromQS(
                current_qs,
                oldstate.filters
            );

        return {
            filters: newfilters,
            activeCount:
                _.filter(
                    newfilters,
                    'active'
                ).length
        };
    }


    /*
     * ============================================================
     * API REQUEST
     * ============================================================
     */

    updateAPIURL(
        current_api_qs,
        newlistprops
    ) {

        const new_qs =
            qs.parse(
                newlistprops.location.search,
                {
                    ignoreQueryPrefix: true
                }
            );


        const treatmentFilters =
            TreatmentFilter.getTreatmentsFromQS(
                new_qs
            );


        /*
         * Only add the treatment filter if something
         * has actually been selected.
         */

        if (
            treatmentFilters.length > 0
        ) {

            const filter_qs = {
                name: 'sample',
                op: 'has',
                val: {
                    name: 'prior_treatment',
                    op: 'in',
                    val: treatmentFilters
                }
            };


            current_api_qs.filter = [
                ...(current_api_qs.filter || []),
                filter_qs
            ];
        }


        /*
         * IMPORTANT:
         *
         * Preserve aggregations already added by
         * the other filters.
         */

        current_api_qs.agg = {
            ...(current_api_qs.agg || {}),
            ...this.aggregates
        };


        return current_api_qs;
    }


    /*
     * ============================================================
     * AGGREGATION RESPONSE
     * ============================================================
     */

    processResponse(response) {

        const resp_agg =
            this.get_agg_values(
                response
            );


        /*
         * If there is no aggregation response,
         * do absolutely nothing.
         *
         * This prevents the filter list being erased.
         */

        if (!resp_agg) {
            return;
        }


        const agg_field =
            _.keys(
                this.aggregates
            )[0];

        const agg_type =
            this.aggregates[
                agg_field
            ];


        /*
         * Get:
         *
         * response
         *   -> sample.prior_treatment
         *      -> count
         */

        const counts =
            _.get(
                resp_agg,
                [
                    agg_field,
                    agg_type
                ]
            );


        /*
         * No treatment aggregation was returned.
         */

        if (
            !counts ||
            typeof counts !== 'object'
        ) {
            return;
        }


        const oldfilters =
            this.state.filters || {};


        const newfilters =
            _.reduce(
                counts,
                (
                    result,
                    count,
                    treatment
                ) => {

                    /*
                     * Ignore empty buckets.
                     */

                    if (
                        treatment === null ||
                        treatment === undefined ||
                        treatment === ''
                    ) {
                        return result;
                    }


                    /*
                     * Preserve active state.
                     */

                    const old =
                        oldfilters[
                            treatment
                        ];


                    result[treatment] = {

                        ...(old || {}),

                        /*
                         * This is the exact value
                         * returned by the API.
                         */

                        filter_name:
                            treatment,

                        count:
                            Number(count) || 0,

                        active:
                            old
                                ? !!old.active
                                : false
                    };


                    return result;

                },
                {}
            );


        /*
         * IMPORTANT:
         *
         * Only replace the filters if the API actually
         * returned treatment values.
         */

        if (
            Object.keys(
                newfilters
            ).length > 0
        ) {

            this.setState({
                filters: newfilters
            });
        }
    }


    /*
     * ============================================================
     * CHECKBOX
     * ============================================================
     */

    toggleCheckbox(event) {

        const treatment =
            event.target.name;


        const current_qs =
            qs.parse(
                window.location.search,
                {
                    ignoreQueryPrefix: true
                }
            );


        let treatmentFilter =
            TreatmentFilter.getTreatmentsFromQS(
                current_qs
            );


        if (
            event.target.checked
        ) {

            if (
                treatmentFilter.indexOf(
                    treatment
                ) === -1
            ) {

                treatmentFilter.push(
                    treatment
                );
            }

        } else {

            treatmentFilter =
                treatmentFilter.filter(
                    item =>
                        item !== treatment
                );
        }


        treatmentFilter =
            _.sortBy(
                treatmentFilter
            );


        if (
            treatmentFilter.length > 0
        ) {

            current_qs.treatment =
                _.join(
                    treatmentFilter,
                    '_'
                );

        } else {

            delete current_qs.treatment;
        }


        delete current_qs.page;


        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }


    /*
     * ============================================================
     * COLLAPSE
     * ============================================================
     */

    toggleCollapse() {

        this.setState({
            isOpen:
                !this.state.isOpen
        });
    }


    /*
     * ============================================================
     * RENDER OPTIONS
     * ============================================================
     */

    renderTreatmentCheckboxes() {

        const filters =
            this.state.filters || {};


        let active = [];
        let inactive = [];


        _.map(
            _.toPairs(filters),
            (
                [treatment, filterProps]
            ) => {

                const count =
                    Number(
                        filterProps.count
                    ) || 0;


                const checkbox = (

                    <FormGroup
                        check
                        key={treatment}
                    >

                        <Input
                            type="checkbox"
                            name={treatment}
                            onChange={
                                this.toggleCheckbox
                            }
                            checked={
                                !!filterProps.active
                            }
                        />

                        {' '}

                        <Label
                            className="ml-4 mt-1"
                            check
                        >

                            {treatment}

                            <span className="secondary">

                                {' '}({count})

                            </span>

                        </Label>

                    </FormGroup>
                );


                if (
                    filterProps.active
                ) {

                    active.push(
                        checkbox
                    );

                } else {

                    inactive.push(
                        checkbox
                    );
                }
            }
        );


        /*
         * Selected options first.
         *
         * Then show enough unselected options
         * to give five visible options.
         */

        if (
            active.length < 5 &&
            active.length +
                inactive.length > 0
        ) {

            active =
                active.concat(
                    inactive.splice(
                        0,
                        5 - active.length
                    )
                );
        }


        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }


    /*
     * ============================================================
     * LIFECYCLE
     * ============================================================
     */

    componentDidMount() {

        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }


    componentWillUnmount() {

        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }


    /*
     * ============================================================
     * RENDER
     * ============================================================
     */

    render() {

        return (

            <Card
                className="treatment-filters mb-2 z0 hover"
            >

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={
                        this.toggleCollapse
                    }
                >

                    <div className="d-inline w-50">
                        Prior Treatment
                    </div>


                    <div className="d-inline-block">

                        {this.state.activeCount > 0 && (

                            <strong>
                                {
                                    this.state.activeCount
                                } active
                            </strong>

                        )}

                    </div>


                    <CollapseButton
                        isOpen={
                            this.state.isOpen
                        }
                        onClick={
                            this.toggleCollapse
                        }
                    />

                </CardHeader>


                <Collapse
                    isOpen={
                        this.state.isOpen
                    }
                >

                    <CardBody>

                        {
                            this.renderTreatmentCheckboxes()
                        }

                    </CardBody>

                </Collapse>

            </Card>
        );
    }
}


export default withRouter(
    TreatmentFilter
);